import React from 'react'
import ForOwnerSideNavBar from './SideNavBar/ForBoatOwner'
import ForShop from './SideNavBar/ForShop'
import SuperAdminSideNavBar from './SideNavBar/ForSuperAdmin'
import ForCaptainSideNavBar from './SideNavBar/ForCaptain'
import ForVendorSideNavBar from './SideNavBar/ForVendor'
import ForPortAdminSideNavBar from './SideNavBar/ForPortAdmin'
import ForConciergeSideNavBar from './SideNavBar/ForConcierge'
import ForWegoSideNavBar from './SideNavBar/ForWego'

class SideNavBar extends React.Component {
  render() {
    return localStorage.getItem('loged_In_role') === 'super-admin' ? (
      <SuperAdminSideNavBar />
    ) : localStorage.getItem('loged_In_role') === 'store' ? (
      <ForShop />
    ) : localStorage.getItem('loged_In_role') === 'admin' ? (
      <ForOwnerSideNavBar />
    ) : localStorage.getItem('loged_In_role') === 'captain' ? (
      <ForCaptainSideNavBar />
    ) : localStorage.getItem('loged_In_role') === 'port-admin' ? (
      <ForPortAdminSideNavBar />
    ) : localStorage.getItem('loged_In_role') === 'concierge' ? (
      <ForConciergeSideNavBar />
    ) : localStorage.getItem('loged_In_role') === 'wego-admin' ? (
      <ForWegoSideNavBar />
    ) : (
      <ForVendorSideNavBar />
    )
  }
}

export default SideNavBar
